import React from 'react';
import { Box, Grid, useTheme } from '@mui/material';
import Logo from '../Common/LogoWithBrandName';

interface AuthPagesLayoutProps {
  children: React.ReactNode;
  xs?: number;
  md?: number;
  lg?: number;
  xl?: number;
  p?: number | string;
}

function AuthPagesLayout({ xs, md, lg, xl, p, children }: AuthPagesLayoutProps) {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      minHeight="100vh"
      sx={{ background: 'linear-gradient(163deg, #FFF 10.13%, #FFF4F0 89.18%)' }}
    >
      <Logo />
      <Grid
        container
        item
        xs={xs}
        md={md}
        lg={lg || md}
        xl={xl || lg || md}
        p={p ?? '32px'}
        minWidth="320px"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="32px"
        bgcolor="#fff"
        borderRadius="10px"
        boxShadow={theme.borderStyles.authCardBorders}
        border="1px solid var(--Brand-Salmon-Pink, #FEE4DB)"
        margin="auto"
      >
        {children}
      </Grid>
    </Box>
  );
}

AuthPagesLayout.defaultProps = {
  xs: 4,
};

export default AuthPagesLayout;
